﻿var moment = require('moment');

module.exports = ['common', 'applicationStateService', 'dataContext', quotaDataService];

function quotaDataService(common, state, context) {

    var service = {
        getOrderDetails: getOrderDetails,
        getQuotas: getQuotas,
        response: null,
        quotaSummaries: [],
        isLoading : false,
        filter: {
            PageNumber: 1,
            referenceDate: moment(state.filter.date, "YYYY-MM-DD").toDate(),
            critical: 'Both',
            blocked: 'Both',
            exhausted: 'Both',
            countryCode: null,
            goodsCode: null,
            orderNumber: null
        }
    };

    function getOrderDetails(orderNumber) {
        var deferred = common.$q.defer();

        var url = common.config.apiHosts[common.config.currentApi] + '/actions/quota/details' +
            '?ordernumber=' + orderNumber +
            '&date=' + state.filter.date;

        context.get(url)
            .then(deferred.resolve, deferred.reject);

        return deferred.promise;
    }

    function getQuotas() {
        service.isLoading = true;
        var critical = (service.filter.critical === 'Both' ? null :(service.filter.critical === 'Yes' ? "Y" : "N"));
        var blocked = (service.filter.blocked === 'Both' ? null :(service.filter.blocked === 'Yes' ? "Y" : "N"));
        var exhausted = (service.filter.exhausted === 'Both' ? null :(service.filter.exhausted === 'Yes' ? "Y" : "N"));
        var url = common.config.apiHosts[common.config.currentApi] + '/actions/quota/quotasummary' +
            '?referencedate=' + state.filter.date + 
            '&pindex=' + (service.filter.PageNumber - 1);  
        if(service.filter.countryCode) {
            url = url + '&country=' + service.filter.countryCode;
        }
        if(service.filter.goodsCode) {
            url = url + '&goodscode=' + service.filter.goodsCode;
        }
        if(service.filter.orderNumber) {
            url = url + '&ordernumber=' + service.filter.orderNumber;
        }
        if(critical) {
            url = url + '&quotacriticalfilter=' + critical;
        }  
        
        if(blocked) {
            url = url + '&quotablockedfilter=' + blocked;
        } 

        if(exhausted) {
            url = url + '&quotaexhaustedfilter=' + exhausted;
        } 

        return context.get(url).then(function (paginatedQuotas) {
            service.isLoading = false;
            service.response = paginatedQuotas;
            quotaSummaries = paginatedQuotas.Results;
        });
    }


    return service;
}